/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Footer_Company_ColInputs */

const en_home_footer_company_col = /** @type {(inputs: Home_Footer_Company_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const fr_home_footer_company_col = /** @type {(inputs: Home_Footer_Company_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entreprise`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Home_Footer_Company_ColInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_footer_company_col = /** @type {((inputs?: Home_Footer_Company_ColInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Footer_Company_ColInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_footer_company_col(inputs)
	return fr_home_footer_company_col(inputs)
});